import { createApi } from "@reduxjs/toolkit/dist/query/react";
import { TENANT_INFO } from "../constants";
import { oktaTokenBaseQuery } from "@/react/services/api/api";

export const tenantInfoApi = createApi({
  baseQuery: oktaTokenBaseQuery(),
  reducerPath: "tenantInfo",
  endpoints: (build) => ({
    getTenantInfo: build.query({
      query: (tenantName) => ({
        url: `/v1/tenants/${tenantName}`,
        method: "GET",
      }),
      providesTags: [TENANT_INFO],
    }),
  }),
});

export const { useGetTenantInfoQuery } = tenantInfoApi;
